import proceed from './proceed';

export default function validateSubmission(
  amount,
  reAmount,
  city,
  street,
  stateLocale,
  zip,
  fieldOfficeRequired,
  fieldOffice,
) {
  //validates if form fields are filled
  // console.log(amount, reAmount, city, street, stateLocale, zip)
  let p;
  //checks if field office selection is required from user
  if (fieldOfficeRequired) {
    p = proceed(
      amount,
      reAmount,
      city,
      street,
      stateLocale,
      zip,
      fieldOfficeRequired,
      fieldOffice,
    );
  } else {
    p = proceed(
      amount,
      reAmount,
      city,
      street,
      stateLocale,
      zip,
      fieldOfficeRequired,
    );
  }

  //validates if amounts match
  if (p.err) {
    switch (p.err) {
      case 'AMOUNT_MISMATCH':
        throw new Error(`Your amounts don't match`);
      case 'MISSING_VAL':
        throw new Error(`Please fill out all required values`);
      default:
        new Error(p.err);
    }
  }
  return;
}
